import React, { forwardRef, useState, useRef, createRef, useImperativeHandle, useEffect, Fragment } from 'react';
import isEqual from 'lodash.isequal';

function getBodyScrollPosition() {
  return Math.max(document.documentElement && document.documentElement.scrollTop, document.body && document.body.scrollTop, document.scrollingElement && document.scrollingElement.scrollTop);
}
function getBodyScrollHeight() {
  return Math.max(document.documentElement && document.documentElement.scrollHeight, document.body && document.body.scrollHeight, document.scrollingElement && document.scrollingElement.scrollHeight);
}

var InfiniteScroll = forwardRef(function (props, ref) {
  var children = props.children,
      dataLength = props.dataLength,
      batchSize = props.batchSize,
      loadMore = props.loadMore,
      hasMore = props.hasMore,
      loader = props.loader,
      threshold = props.threshold,
      parentRef = props.parentRef,
      manualLoadFirstSet = props.manualLoadFirstSet,
      resetDependencies = props.resetDependencies,
      disabled = props.disabled,
      beforeEachLoad = props.beforeEachLoad;
  var defaultThreshold = 250;

  var _useState = useState(resetDependencies),
      previousResetDependencies = _useState[0],
      setPreviousResetDependencies = _useState[1];

  var _useState2 = useState(0),
      nextPageToLoad = _useState2[0],
      setNextPageToLoad = _useState2[1];

  var lastPageLoadedRef = useRef(-1);
  var wrapperRef = createRef();

  var getNextPageToLoad = function getNextPageToLoad() {
    return Math.ceil((dataLength || 0) / (batchSize || 1));
  };

  var reset = function reset() {
    setPreviousResetDependencies(resetDependencies);
    lastPageLoadedRef.current = -1;
    setNextPageToLoad(0);
  };

  useImperativeHandle(ref, function () {
    return {
      reset: reset
    };
  });
  useEffect(function () {
    var newNextPageToLoad = getNextPageToLoad();
    setNextPageToLoad(newNextPageToLoad);
  }, [dataLength]);

  var load = function load() {
    var _wrapperRef$current, _wrapperRef$current$p;

    if (disabled) {
      return;
    }

    if (manualLoadFirstSet && nextPageToLoad === 0) {
      return;
    }

    var parentElement = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current;
    var scrollPosition = parentElement ? parentElement.scrollTop + parentElement.offsetHeight : getBodyScrollPosition() + window.innerHeight;
    var scrollHeight = parentElement ? parentElement.scrollHeight : getBodyScrollHeight();
    var thresholdExceeded = scrollHeight - scrollPosition < (threshold || defaultThreshold);
    var isPageLoaded = nextPageToLoad <= lastPageLoadedRef.current;
    var isParentHidden = (wrapperRef === null || wrapperRef === void 0 ? void 0 : (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : (_wrapperRef$current$p = _wrapperRef$current.parentElement) === null || _wrapperRef$current$p === void 0 ? void 0 : _wrapperRef$current$p.offsetHeight) === 0;

    if (hasMore && thresholdExceeded && !isPageLoaded && !isParentHidden) {
      lastPageLoadedRef.current = nextPageToLoad;
      loadMore(nextPageToLoad, {
        limit: batchSize,
        offset: nextPageToLoad * batchSize
      });
    }
  };

  useEffect(function () {
    if (disabled) {
      return;
    }

    var stopNextLoad = beforeEachLoad === null || beforeEachLoad === void 0 ? void 0 : beforeEachLoad({
      reset: reset
    });

    if (stopNextLoad) {
      return;
    }

    if (!isEqual(resetDependencies, previousResetDependencies)) {
      reset();
      return;
    }

    var parentElement = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current;
    (parentElement || window).addEventListener('scroll', load);
    (parentElement || window).addEventListener('resize', load);
    load();
    return function () {
      (parentElement || window).removeEventListener('scroll', load);
      (parentElement || window).removeEventListener('resize', load);
    };
  });
  return React.createElement(Fragment, null, React.createElement("div", {
    ref: wrapperRef,
    style: {
      display: 'none'
    }
  }), children, hasMore && loader);
});

export default InfiniteScroll;
//# sourceMappingURL=index.modern.js.map
